module.exports = __webpack_public_path__ + "img/service2-01.e0e815de.png";